import type { SelectChangeEvent } from "@mui/material";
import { Select } from "@mui/material";
import type { ReactNode } from "react";
import { useState } from "react";

interface SingleSelectInputProps {
  defaultValue: string | null;
  onInputChange?: (...values: unknown[]) => void;
  children: ReactNode | ReactNode[];
  disabled?: boolean;
}

const SingleSelectInput = ({
  defaultValue,
  onInputChange,
  children,
  disabled,
}: SingleSelectInputProps) => {
  const [value, setValue] = useState(defaultValue ?? "");
  const onChange = (e: SelectChangeEvent): void => {
    setValue(e.target.value);
    if (onInputChange) {
      onInputChange(e.target.value);
    }
  };

  return (
    <Select
      className="mt-2 min-h-[2.5rem] w-full"
      onChange={onChange}
      displayEmpty
      renderValue={(selected) => {
        if (!selected) {
          return <span style={{ color: '#999' }}>Select an option</span>;
        }
        return selected;
      }}
      readOnly={disabled}
      value={value}
    >
      {children}
    </Select>
  );
};

export default SingleSelectInput;
